import React from 'react'
import ModalWrapper from '../../common/Modal/ModalWrapper'
import { padding } from '@mui/system'

const FractionHelpClientInfoModal = () => {

    const data = [
        'We introduce new client opportunities from SeedLegals, top 10 accountants etc',
        'Leverages AI at scale to deliver tools you can’t develop yourselves',
        'Better tools increases income and secure longevity - for everyone',
        'Admin/management reporting across your base',
        'Makes both your client base and CFO base stickier',
        'Community-building tools (coming soon)',
    ]

    return (
        <ModalWrapper
            modalType={'fractionHelpClientInfo'}
            modalCardClasses='maw1000px'
            customStyle={{
                padding: '3rem 3rem 5rem',
                overflow: 'visible'
            }}
        >

            <div className='pr'>
                <h1 className='w100 tac fs2rem c15 mb1rem'>Benefits for CFO organisations</h1>

                <div className='dg gtcr1-sm gtcr2a-md gg1rem mt2rem'>
                    {
                        data.map((item, ind) => {
                            return (
                                <div className='df aifs jcfs mt1rem'>
                                    <p className='bo4 p1rem fs1rem fw500 br50px bss bw2px df aic jcc c15' style={{ width: '50px', height: '50px' }}>{ind + 1}</p>
                                    <p className='ml1rem w70' style={{ color: '#505050' }}>{item}</p>
                                </div>
                            )
                        })
                    }

                </div>

            </div>
            <img
                src={require('../../../../images/fractional/helpClient/prize.svg')}
                alt="prize"
                className='pa'
                style={{
                    right: '-180px',
                    bottom: '-130px',
                    width: '244px',
                    height: '199px'
                }} />

        </ModalWrapper>
    )
}

export default FractionHelpClientInfoModal